export const SET_SEARCHES = "SET_SEEARCHES";
export const ADD_SEARCHES = "ADD_SEARCHES";
export const UPDATE_USER_IN_SEARCH_LIST = "UPDATE_USER_IN_SEARCH_LIST";
export const CLEAR_SEARCHES = "CLEAR_SEARCHES";
export const DEFAULT = "DEFAULT";